module.exports = __webpack_public_path__ + "static/media/icon_Reset_web.ce9484fc.svg";